import React, { useState, useEffect, useContext } from "react";
import { ServiceWatchListContext, ThemeContext } from "../../layout/BaseLayout";
import Draggable from "react-draggable";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { ModalDialog } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
// import TimezoneSelect from "react-timezone-select"
import Select from "react-select"
import { dashboardDetails, updateDashboardTimezone } from "../../services/dashboardService";
import { getLicenceAndWhiteLabelList } from "../../services/serviceWatchService";
import NoDataError from "../../components/NoDataError";
import { useNavigate } from "react-router-dom";

const eodmodel = (props) => {
   return (
      <Draggable handle=".modal-header">
         <ModalDialog {...props} />
      </Draggable>
   );
};


function HomePage(props) {
   let toast = useContext(ThemeContext);
   let serviceWatchList = useContext(ServiceWatchListContext);
   let token = sessionStorage.getItem("token");
   const [showeod, setShoweod] = useState(false);
   const [selectedTimezone, setSelectedTimezone] = useState({})
   const [dashboardData, setdashboardData] = useState({});
   const [licenceList, setLicenceList] = useState({});
   const [updatedLicenceList, setUpdatedLicenceList] = useState([]);
   const [loadingState, setLoadingState] = useState({});
   // const [selectedArr, setSelectedArr] = useState([]);

   const navigate = useNavigate();

   const timezoneOptions = [
      { value: "Pacific/Midway", label: "(UTC-11:00) Midway Island, Samoa", },
      { value: "Pacific/Honolulu", label: "(UTC-10:00) Hawaii" },
      { value: "America/Juneau", label: "(UTC-8:00) Alaska" },
      { value: "America/Boise", label: "(UTC-07:00) Mountain Time" },
      { value: "America/Dawson", label: "(UTC-07:00) Dawson, Yukon" },
      { value: "America/Chihuahua", label: "(UTC-06:00) Chihuahua, La Paz, Mazatlan" },
      { value: "America/Phoenix", label: "(UTC-07:00) Arizona" },
      { value: "America/Chicago", label: "(UTC-06:00) Central Time" },
      { value: "America/Regina", label: "(UTC-06:00) Saskatchewan" },
      { value: "America/Mexico_City", label: "(UTC-05:00) Guadalajara, Mexico City, Monterrey" },
      { value: "America/Belize", label: "(UTC-06:00) Central America" },
      { value: "America/Detroit", label: "(UTC-04:00) Eastern Time" },
      { value: "America/Bogota", label: "(UTC-05:00) Bogota, Lima, Quito" },
      { value: "America/Caracas", label: "(UTC-04:00) Caracas, La Paz" },
      { value: "America/Santiago", label: "(UTC-04:00) Santiago" },
      { value: "America/St_Johns", label: "(UTC-03:30) Newfoundland and Labrador" },
      { value: "America/Sao_Paulo", label: "(UTC-03:00) Brasilia" },
      { value: "America/Tijuana", label: "(UTC-07:00) Tijuana" },
      { value: "America/Montevideo", label: "(UTC-03:00) Montevideo" },
      { value: "America/Argentina/Buenos_Aires", label: "(UTC-03:00) Buenos Aires, Georgetown" },
      { value: "America/Godthab", label: "(UTC-02:00) Greenland" },
      { value: "America/Los_Angeles", label: "(UTC-07:00) Pacific Time" },
      { value: "Atlantic/Azores", label: "(UTC+00:00) Azores" },
      { value: "Atlantic/Cape_Verde", label: "(UTC-01:00) Cape Verde Islands" },
      { value: "GMT", label: "(UTC+00:00) UTC" },
      { value: "Europe/London", label: "(UTC+01:00) Edinburgh, London" },
      { value: "Europe/Dublin", label: "(UTC+01:00) Dublin" },
      { value: "Europe/Lisbon", label: "(UTC+01:00) Lisbon" },
      { value: "Africa/Casablanca", label: "(UTC+01:00) Casablanca, Monrovia" },
      { value: "Atlantic/Canary", label: "(UTC+01:00) Canary Islands" },
      { value: "Europe/Belgrade", label: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague" },
      { value: "Europe/Amsterdam", label: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna" },
      { value: "Africa/Algiers", label: "(UTC+01:00) West Central Africa" },
      { value: "Europe/Bucharest", label: "(UTC+02:00) Bucharest" },
      { value: "Africa/Cairo", label: "(UTC+02:00) Cairo" },
      { value: "Europe/Sarajevo", label: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb" },
      { value: "Europe/Brussels", label: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris" },
      { value: "Europe/Helsinki", label: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius" },
      { value: "Europe/Athens", label: "(GMT+02:00) Athens, Minsk" },
      { value: "Asia/Jerusalem", label: "(GMT+02:00) Jerusalem" },
      { value: "Africa/Harare", label: "(GMT+02:00) Harare, Pretoria" },
      { value: "Europe/Moscow", label: "(GMT+03:00) Istanbul, Moscow, St. Petersburg, Volgograd" },
      { value: "Asia/Kuwait", label: "(GMT+03:00) Kuwait, Riyadh" },
      { value: "Africa/Nairobi", label: "(GMT+03:00) Nairobi" },
      { value: "Asia/Baghdad", label: "(GMT+03:00) Baghdad" },
      { value: "Asia/Tehran", label: "(GMT+04:30) Tehran" },
      { value: "Asia/Dubai", label: "(GMT+04:00) Abu Dhabi, Muscat" },
      { value: "Asia/Baku", label: "(GMT+04:00) Baku, Tbilisi, Yerevan" },
      { value: "Asia/Kabul", label: "(GMT+04:30) Kabul" },
      { value: "Asia/Yekaterinburg", label: "(GMT+05:00) Ekaterinburg" },
      { value: "Asia/Karachi", label: "(GMT+05:00) Islamabad, Karachi, Tashkent" },
      { value: "Asia/Kolkata", label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi" },
      { value: "Asia/Kathmandu", label: "(GMT+05:45) Kathmandu" },
      { value: "Asia/Dhaka", label: "(GMT+06:00) Astana, Dhaka" },
      { value: "Asia/Colombo", label: "(GMT+05:30) Sri Jayawardenepura" },
      { value: "Asia/Almaty", label: "(GMT+06:00) Almaty, Novosibirsk" },
      { value: "Asia/Rangoon", label: "(GMT+06:30) Yangon (Rangoon)" },
      { value: "Asia/Bangkok", label: "(GMT+07:00) Bangkok, Hanoi, Jakarta" },
      { value: "Asia/Krasnoyarsk", label: "(GMT+07:00) Krasnoyarsk" },
      { value: "Asia/Shanghai", label: "(GMT+08:00) Beijing, Chongqing, Hong Kong SAR, Urumqi" },
      { value: "Asia/Kuala_Lumpur", label: "(GMT+08:00) Kuala Lumpur, Singapore" },
      { value: "Asia/Taipei", label: "(GMT+08:00) Taipei" },
      { value: "Australia/Perth", label: "(GMT+08:00) Perth" },
      { value: "Asia/Irkutsk", label: "(GMT+08:00) Irkutsk, Ulaanbaatar" },
      { value: "Asia/Seoul", label: "(GMT+09:00) Seoul" },
      { value: "Asia/Tokyo", label: "(GMT +9:00) Osaka, Sapporo, Tokyo" },
      { value: "Asia/Yakutsk", label: "(GMT +9:00) Yakutsk" },
      { value: "Australia/Darwin", label: "(GMT +9:30) Darwin" },
      { value: "Australia/Adelaide", label: "(GMT +10:30) Adelaide" },
      { value: "Australia/Sydney", label: "(GMT +11:00) Canberra, Melbourne, Sydney" },
      { value: "Australia/Brisbane", label: "(GMT +10:00) Brisbane" },
      { value: "Australia/Hobart", label: "(GMT +10:00) Hobart" },
      { value: "Asia/Vladivostok", label: "(GMT +10:00) Vladivostok" },
      { value: "Pacific/Guam", label: "(GMT +10:00) Guam, Port Moresby" },
      { value: "Asia/Magadan", label: "(GMT +11:00) Magadan, Solomon Islands, New Caledonia" },
      { value: "Asia/Kamchatka", label: "(GMT +12:00) Kamchatka, Marshall Islands" },
      { value: "Pacific/Fiji", label: "(GMT +12:00) Fiji Islands" },
      { value: "Pacific/Auckland", label: "(GMT +12:00) Auckland, Wellington" },
      { value: "Pacific/Tongatapu", label: "(GMT +13:00) Nuku'alofa" }
   ]

   const timeZoneDict = {
      "Africa/Bangui": "W. Central Africa Standard Time",
      "Africa/Cairo": "Egypt Standard Time",
      "Africa/Casablanca": "Morocco Standard Time",
      "Africa/Harare": "South Africa Standard Time",
      "Africa/Johannesburg": "South Africa Standard Time",
      "Africa/Lagos": "W. Central Africa Standard Time",
      "Africa/Monrovia": "Greenwich Standard Time",
      "Africa/Nairobi": "E. Africa Standard Time",
      "Africa/Windhoek": "Namibia Standard Time",
      "America/Anchorage": "Alaskan Standard Time",
      "America/Argentina/San_Juan": "Argentina Standard Time",
      "America/Asuncion": "Paraguay Standard Time",
      "America/Bahia": "Bahia Standard Time",
      "America/Bogota": "SA Pacific Standard Time",
      "America/Buenos_Aires": "Argentina Standard Time",
      "America/Caracas": "Venezuela Standard Time",
      "America/Cayenne": "SA Eastern Standard Time",
      "America/Chicago": "Central Standard Time",
      "America/Chihuahua": "Mountain Standard Time (Mexico)",
      "America/Cuiaba": "Central Brazilian Standard Time",
      "America/Denver": "Mountain Standard Time",
      "America/Fortaleza": "SA Eastern Standard Time",
      "America/Godthab": "Greenland Standard Time",
      "America/Guatemala": "Central America Standard Time",
      "America/Halifax": "Atlantic Standard Time",
      "America/Indianapolis": "US Eastern Standard Time",
      "America/Indiana/Indianapolis": "US Eastern Standard Time",
      "America/La_Paz": "SA Western Standard Time",
      "America/Los_Angeles": "Pacific Standard Time",
      "America/Mexico_City": "Mexico Standard Time",
      "America/Montevideo": "Montevideo Standard Time",
      "America/New_York": "Eastern Standard Time",
      "America/Noronha": "UTC-02",
      "America/Phoenix": "US Mountain Standard Time",
      "America/Regina": "Canada Central Standard Time",
      "America/Santa_Isabel": "Pacific Standard Time (Mexico)",
      "America/Santiago": "Pacific SA Standard Time",
      "America/Sao_Paulo": "E. South America Standard Time",
      "America/St_Johns": "Newfoundland Standard Time",
      "America/Tijuana": "Pacific Standard Time",
      "Antarctica/McMurdo": "New Zealand Standard Time",
      "Atlantic/South_Georgia": "UTC-02",
      "Asia/Almaty": "Central Asia Standard Time",
      "Asia/Amman": "Jordan Standard Time",
      "Asia/Baghdad": "Arabic Standard Time",
      "Asia/Baku": "Azerbaijan Standard Time",
      "Asia/Bangkok": "SE Asia Standard Time",
      "Asia/Beirut": "Middle East Standard Time",
      "Asia/Calcutta": "India Standard Time",
      "Asia/Colombo": "Sri Lanka Standard Time",
      "Asia/Damascus": "Syria Standard Time",
      "Asia/Dhaka": "Bangladesh Standard Time",
      "Asia/Dubai": "Arabian Standard Time",
      "Asia/Irkutsk": "North Asia East Standard Time",
      "Asia/Jerusalem": "Israel Standard Time",
      "Asia/Kabul": "Afghanistan Standard Time",
      "Asia/Kamchatka": "Kamchatka Standard Time",
      "Asia/Karachi": "Pakistan Standard Time",
      "Asia/Katmandu": "Nepal Standard Time",
      "Asia/Kolkata": "India Standard Time",
      "Asia/Krasnoyarsk": "North Asia Standard Time",
      "Asia/Kuala_Lumpur": "Singapore Standard Time",
      "Asia/Kuwait": "Arab Standard Time",
      "Asia/Magadan": "Magadan Standard Time",
      "Asia/Muscat": "Arabian Standard Time",
      "Asia/Novosibirsk": "N. Central Asia Standard Time",
      "Asia/Oral": "West Asia Standard Time",
      "Asia/Rangoon": "Myanmar Standard Time",
      "Asia/Riyadh": "Arab Standard Time",
      "Asia/Seoul": "Korea Standard Time",
      "Asia/Shanghai": "China Standard Time",
      "Asia/Singapore": "Singapore Standard Time",
      "Asia/Taipei": "Taipei Standard Time",
      "Asia/Tashkent": "West Asia Standard Time",
      "Asia/Tbilisi": "Georgian Standard Time",
      "Asia/Tehran": "Iran Standard Time",
      "Asia/Tokyo": "Tokyo Standard Time",
      "Asia/Ulaanbaatar": "Ulaanbaatar Standard Time",
      "Asia/Vladivostok": "Vladivostok Standard Time",
      "Asia/Yakutsk": "Yakutsk Standard Time",
      "Asia/Yekaterinburg": "Ekaterinburg Standard Time",
      "Asia/Yerevan": "Armenian Standard Time",
      "Atlantic/Azores": "Azores Standard Time",
      "Atlantic/Cape_Verde": "Cape Verde Standard Time",
      "Atlantic/Reykjavik": "Greenwich Standard Time",
      "Australia/Adelaide": "Cen. Australia Standard Time",
      "Australia/Brisbane": "E. Australia Standard Time",
      "Australia/Darwin": "AUS Central Standard Time",
      "Australia/Hobart": "Tasmania Standard Time",
      "Australia/Perth": "W. Australia Standard Time",
      "Australia/Sydney": "AUS Eastern Standard Time",
      "GMT": "UTC",
      "Etc/GMT+11": "UTC-11",
      "Etc/GMT+12": "Dateline Standard Time",
      "Etc/GMT+2": "UTC-02",
      "Etc/GMT-12": "UTC+12",
      "Europe/Amsterdam": "W. Europe Standard Time",
      "Europe/Athens": "GTB Standard Time",
      "Europe/Belgrade": "Central Europe Standard Time",
      "Europe/Berlin": "W. Europe Standard Time",
      "Europe/Brussels": "Romance Standard Time",
      "Europe/Budapest": "Central Europe Standard Time",
      "Europe/Dublin": "GMT Standard Time",
      "Europe/Helsinki": "FLE Standard Time",
      "Europe/Istanbul": "GTB Standard Time",
      "Europe/Kiev": "FLE Standard Time",
      "Europe/London": "GMT Standard Time",
      "Europe/Minsk": "E. Europe Standard Time",
      "Europe/Moscow": "Russian Standard Time",
      "Europe/Paris": "Romance Standard Time",
      "Europe/Sarajevo": "Central European Standard Time",
      "Europe/Warsaw": "Central European Standard Time",
      "Indian/Mauritius": "Mauritius Standard Time",
      "Pacific/Apia": "Samoa Standard Time",
      "Pacific/Auckland": "New Zealand Standard Time",
      "Pacific/Fiji": "Fiji Standard Time",
      "Pacific/Guadalcanal": "Central Pacific Standard Time",
      "Pacific/Guam": "West Pacific Standard Time",
      "Pacific/Honolulu": "Hawaiian Standard Time",
      "Pacific/Pago_Pago": "UTC-11",
      "Pacific/Port_Moresby": "West Pacific Standard Time",
      "Pacific/Tongatapu": "Tonga Standard Time",
      "Pacific/Midway": "Samoa Standard Time",
      "America/Juneau": "Alaska Daylight Time",
      "America/Boise": "Mountain Daylight Time",
      "America/Dawson": "Pacific Standard Time",
      "America/Belize": "Central Standard Time",
      "America/Detroit": "Eastern Daylight Time",
      "America/Argentina/Buenos_Aires": "Argentina Standard Time",
      "Europe/Lisbon": "Western European Summer Time",
      "Atlantic/Canary": " Western European Time ",
      "Africa/Algiers": "Central European Standard Time",
      "Europe/Bucharest": "Eastern European Summer Time",
      "Asia/Kathmandu": "Nepal Time"
   };

   const eodClose = () => setShoweod(false);
   const eodOpen = () => {
      setSelectedTimezone(!!dashboardData && !!dashboardData.licenseTimezone ? dashboardData.licenseTimezone : {})
      setShoweod(true);
   }

   // const generateTimeZoneList = () => {
   //    const timeZoneNames = Intl.supportedValuesOf('timeZone');
   //    const timeZonesArray = timeZoneNames.map((zone) => {
   //      const tz = Intl.DateTimeFormat(undefined, { timeZone: zone }).resolvedOptions();
   //      return { value: zone, altName: tz.timeZoneName };
   //    });
   //  };

   const onUpdateTimeZone = () => {
      let timezoneobj = {
         "value": selectedTimezone.value,
         "label": selectedTimezone.label,
         "offset": 0,
         "abbrev": "",
         "altName": timeZoneDict[selectedTimezone.value]
      }
      updateDashboardTimezone(timezoneobj).then((res) => {
         if (!!res.isSuccess) {
            eodClose()
            toast.success(!!res && !!res?.successMessage && res?.successMessage);
            getDashboardDetails()
         }
         else {
            toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
         }
      })
   }

   const getDashboardDetails = () => {
      dashboardDetails().then((res) => {
         if (!!res.isSuccess) {
            setdashboardData(!!res && !!res.data && res.data);
            sessionStorage.setItem('timezone', JSON.stringify(res.data.licenseTimezone))
         }
         else {
            toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
         }
      })
   }

   const getLicenceDetail = () => {
      getLicenceAndWhiteLabelList().then((res) => {
         if (res.isSuccess) {
            let dta = res?.data?.filter((itm) => !itm.whiteLabel);
            const groupingData = dta.reduce((grps, item) => {
               const opCode = item.operatorId;
               if (!grps[opCode]) {
                  grps[opCode] = {}
               }
               const newArr = serviceWatchList?.filter((itm) => itm.ServiceType === "IIS").map(obj => ({ ...obj, domain: item?.primaryDomain, operatorId: item?.operatorId, companyName: item?.companyName, licenseStatus: item?.licenseStatus }))
               grps[opCode] = newArr;
               return grps
            }, {})
            setLicenceList(groupingData);

            const initialLoadingState = Object.keys(groupingData).reduce((acc, key) => {
               acc[key] = true;
               return acc;
            }, {});
            setLoadingState(initialLoadingState);
         }
      })
   }

   const checkServiceHealth = async (url) => {
      try {
         const response = await fetch(url, { method: 'GET' });
         return response.ok ? 'Healthy' : 'Unhealthy';
      } catch (error) {
         return 'Unhealthy';
      }
   };

   const checkApiHealth = async () => {
      let updatedFilteredLicence = { ...updatedLicenceList };
      for (const [key, services] of Object.entries(licenceList)) {
         const filteredServices = services.filter((service) => service.licenseStatus !== false);
         const statuses = await Promise.all(
            filteredServices.map(async (service) => {
               const url = `https://${service.Endpoint}.${service.domain}:${service.Port}`;
               return await checkServiceHealth(url);
            })
         );

         const healthyCount = statuses.filter((status) => status === 'Healthy').length;
         const unhealthyCount = statuses.length - healthyCount;

         updatedFilteredLicence[key] = {
            total: statuses.length,
            healthy: healthyCount,
            unhealthy: unhealthyCount,
            companyName: services[0].companyName,
            operatorId: services[0].operatorId,
         };

         setLoadingState((prev) => ({ ...prev, [key]: false }));
         setUpdatedLicenceList((prev) => ({ ...prev, [key]: updatedFilteredLicence[key] }));
      }
   };

   // const onSelectionRow = (item) => {
   //    if (!!Object.entries(licenceList) && Object.entries(licenceList).length > 0) {
   //       const selectedRow = licenceList[item].map((elem) => { return elem.operatorId }).indexOf(item);
   //       if (selectedRow > -1) {
   //          setSelectedArr([licenceList[item][selectedRow]]);
   //       }
   //    }
   // }

   // const checkItem = (item) => {
   //    const checkData = !!selectedArr && selectedArr.some((val) => val?.operatorId === item?.operatorId);
   //    return checkData;
   // }

   useEffect(() => {
      if (Object.keys(licenceList).length > 0) {
         checkApiHealth();
      }
   }, [licenceList]);

   useEffect(() => {
      if (!!token && serviceWatchList?.length > 0) {
         getLicenceDetail();
      }
   }, [token, serviceWatchList]);

   return (
      <>
         <div id="tabs">
            <div className="maintitle-box d-block">
               <h2 className="maintitle d-inline-block">Welcome to Master Admin Panel</h2>
               {/* <h2 className="maintitle d-inline-block">{!!dashboardData && !!dashboardData.companyName && dashboardData.companyName}</h2> */}
               {/* <p className="maintitle-text mb-0">Live build -. Latest release build used</p> */}
            </div>
            <div className="container-fluid mt-3">
               Dashboard - Coming soon....
               {/* <div className="row">
                  <div className="col-12 col-sm-4 col-md-3">
                     <div className="hometitle"><img className="dashboard-img" src={"/images/svg/server.svg"} alt="" />Server Name</div>
                     <div className="hometitle-inner">{dashboardData?.orderServerName}</div>
                  </div>
                  <div className="col-12 col-sm-4 col-md-3">
                     <div className="hometitle"><img className="dashboard-img" src={"/images/svg/key.svg"} alt="" />License Key</div>
                     <div className="hometitle-inner">{!!dashboardData && !!dashboardData.licenseKey && dashboardData.licenseKey}</div>
                  </div>
                  <div className="col-12 col-sm-4 col-md-3">
                     <div className="hometitle"><img className="dashboard-img" src={"/images/svg/licence-valid.svg"} alt="" />License Valid Till</div>
                     <div className="hometitle-inner">{!!dashboardData && !!dashboardData.licenseEndDate && (new Date(dashboardData.licenseEndDate).toLocaleDateString("IN-hi"))}</div>
                  </div>
                  <div className="col-12 col-sm-4 col-md-3">
                     <div className="hometitle"><img className="dashboard-img" src={"/images/svg/symbol.svg"} alt="" />Symbols</div>
                     <div className="hometitle-inner">{!!dashboardData && !!dashboardData.symbolsLimit && dashboardData.symbolsLimit}</div>
                  </div>
               </div>
               <div className="row mt-3">
                  <div className="col-12 col-sm-4 col-md-3">
                     <div className="hometitle"> <img className="dashboard-img" src={"/images/svg/groups.svg"} alt="" />Groups</div>
                     <div className="hometitle-inner">{!!dashboardData && !!dashboardData.groupsLimit && dashboardData.groupsLimit}</div>
                  </div>
                  <div className="col-12 col-sm-4 col-md-3">
                     <div className="hometitle"><img className="dashboard-img" src={"/images/svg/dealers.svg"} alt="" />Dealers</div>
                     <div className="hometitle-inner">{!!dashboardData && !!dashboardData.dealersLimit && dashboardData.dealersLimit}</div>
                  </div>
                  <div className="col-12 col-sm-4 col-md-3">
                     <div className="hometitle"><img className="dashboard-img" src={"/images/svg/clients.svg"} alt="" />Clients</div>
                     <div className="hometitle-inner">{!!dashboardData && !!dashboardData.clientsLimit && dashboardData.clientsLimit}</div>
                  </div>
                  <div className="col-12 col-sm-4 col-md-3">
                     <div className="hometitle"><img className="dashboard-img" src={"/images/svg/sharing.svg"} alt="" />License Sharing</div>
                     <div className="hometitle-inner">{!!dashboardData && dashboardData.licenseSharing}%</div>
                  </div>
               </div>
               <div className="row mt-3">
                  <div className="col-12 col-sm-4 col-md-3">
                     <div className="hometitle"><img className="dashboard-img" src={"/images/svg/status.svg"} alt="" />License Status</div>
                     <div className="hometitle-inner">{!!dashboardData && !!dashboardData.licenseStatus && dashboardData.licenseStatus ? "Active" : "Inactive"}</div>
                  </div>
                  <div className="col-12 col-sm-6 col-md-6">
                     <div className="hometitle"><img className="dashboard-img" src={"/images/svg/security-session.svg"} alt="" />Timezone</div>
                     <div className="hometitle-inner">
                        <span className="mr-2">{!!dashboardData && !!dashboardData.licenseTimezone && !!dashboardData.licenseTimezone.label && dashboardData.licenseTimezone.label}</span>
                        {/* <span><button className="mb-0 ml-2 btn-small" onClick={eodOpen} >Change Timezone</button></span> *}
                        <span onClick={eodOpen} title="Change TimeZone" ><i className="fa fa-pen-to-square font-size-16"></i></span>
                     </div>
                  </div>
               </div>

               <div className="row mt-5">
                  <div className="col-12 col-sm-12 col-md-12">
                     <div className="hometitle">Alerts</div>
                     <div className="hometitle text-success d-none">METAODDS Leads is available to you, <a href="" className="hometitle-ancor">check out the offer</a></div>

                  </div>
               </div> */}
            </div>
            <div className="thead-fixed mt-3">
               <table className="table table-bordered table-strip w-100 mb-30 new-data-asc-desc">
                  <thead>
                     <tr className="thead-dard-bg">
                        <td className=" srn-width">Sr</td>
                        <td className=" srn-width">Licence</td>
                        <td className=" srn-width">Total Service Count</td>
                        <td className=" srn-width">Active Service Count</td>
                        <td className=" srn-width">Inactive Service Count</td>
                     </tr>
                  </thead>
                  <tbody>
                     {Object.entries(licenceList)?.map(([group, services], index) => (
                        <tr
                           key={group}
                           className={`${!services[0]?.licenseStatus ? 'text-pink' : ''} `}
                           onDoubleClick={() => {
                              navigate(`/servicewatch/${services[0]?.operatorId}`);
                              sessionStorage.setItem("selectedId", JSON.stringify(11));
                           }}
                           // onClick={() => onSelectionRow(services[0].operatorId)}
                        >
                           <td>{index + 1}</td>
                           <td>{`${services[0]?.companyName} - ${services[0]?.operatorId}`}</td>
                           <td>
                              {loadingState[group] ? (
                                 <span>{`${!services[0]?.licenseStatus ? "-" : "Loading..."}`}</span>
                              ) : (
                                 !services[0]?.licenseStatus ? "-" : updatedLicenceList[group]?.total || services.length
                              )}
                           </td>
                           <td className="text-success">
                              {loadingState[group] ? (
                                 <span>{`${!services[0]?.licenseStatus ? "-" : "Loading..."}`}</span>
                              ) : (
                                 !services[0]?.licenseStatus ? "-" : updatedLicenceList[group]?.healthy || 0
                              )}
                           </td>
                           <td className="text-danger">
                              {loadingState[group] ? (
                                 <span>{`${!services[0]?.licenseStatus ? "-" : "Loading..."}`}</span>
                              ) : (
                                 !services[0]?.licenseStatus ? "-" : updatedLicenceList[group]?.unhealthy || 0
                              )}
                           </td>
                        </tr>
                     ))}
                  </tbody>
               </table>
            </div>
         </div>

         <div className="login-popup">
            <Modal className="login"
               show={showeod}
               onHide={() => eodClose()}
               backdrop="static"
               dialogAs={eodmodel}
               animation={false}
               size="md"
               centered
            >
               <Modal.Header closeButton style={{ border: "none" }}>
                  <Modal.Title>Change Timezone</Modal.Title>
               </Modal.Header>
               <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                  <div className="p1">
                     <div className=" loginbox">
                        <div>
                           <label htmlFor="email" className="font-bold d-block"><img className="dashboard-img-pop" src={"/images/svg/security-session.svg"} alt="" />Select Timezone:</label>
                           <div className="select-wrapper">
                              <Select
                                 value={selectedTimezone}
                                 onChange={setSelectedTimezone}
                                 options={timezoneOptions}
                                 className="react-timezone-box"
                                 classNamePrefix="react-timezone"
                              />
                           </div>
                        </div>
                     </div>

                  </div>
                  <div className="hr"></div>
                  <div className="p1">
                     <div className="w-100 text-right">
                        <Button onClick={() => onUpdateTimeZone()} className="btnmain mr-3"> Update </Button>
                        <Button onClick={() => eodClose()} className="btnmain-danger btn btn-primary"> Cancel </Button>
                     </div>
                  </div>

               </Modal.Body>
            </Modal>
         </div>

      </>
   );

}
export default HomePage;
